import { useContext } from "react"
import Sidebar from "./components/Sidebar/Sidebar"
import ChatSection from "./components/chatSection/ChatSection"
import Separation from "./components/seperation/separation"
import { dataContext } from "./context/UserContext"

function App() {

  return (
    <>
      <Sidebar />
      <Separation />
      <ChatSection />
    </>
  )
}

export default App
